import { PackingTaskListPage } from "@/features/packing-task/pages/PackingTaskListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/packing-task/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["packing_task.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PackingTaskListPage,
});
